import { render, staticRenderFns } from "./OptionsIntroContainer.vue?vue&type=template&id=32014b04"
import script from "./OptionsIntroContainer.vue?vue&type=script&lang=js"
export * from "./OptionsIntroContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports